import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages(
    'pages.RequestFormPage.XeroAirwallexBatchPaymentForm.BillsInformation.AddBeneficiaryPopupContent.StepsIndicator',
    {
        general: 'General Information',
        paymentMethod: 'Payment method',
        additionalDetails: 'Bank and address details',
        preview: 'Preview check',
    }
);
